import React, { useContext } from 'react'
import { QuizContext } from '../context/QuizContext'
import Card from './Card'
import QuizAnimation from './QuizAnimation'

const QuizCard = React.forwardRef((props, ref) => {
  const {cardData, questionType, question, animationData, selected, animating} = props
  const {questionInfo} = useContext(QuizContext)
  let {title, cardText, ...filteredData} = {...cardData}
  
  const shouldAnimate = (question && animating) || (!question && animating && selected)

  const cardToExample = questionType === 'cardToExample'
  const exampleToCard = questionType === 'exampleToCard'
  const titleToDescription = questionType === 'titleToDescription'
  const descriptionToTitle = questionType === 'descriptionToTitle'
  const titleToExample = questionType === 'titleToExample'
  
  //Done to change colors of answers to match question
  //const questionCategory = (!question && !exampleToCard) ? questionInfo.categoryId : null
  const questionCategory = null

  const imageMode = (!question && (cardToExample || titleToExample)) || (question && exampleToCard)
  if ((!question && titleToDescription) || (question && descriptionToTitle)) {
    filteredData.cardText = cardText
  }
  else if ((!question && descriptionToTitle) || (question && titleToDescription)) {
    filteredData.title = title
  } else {
    filteredData = {...filteredData, title, cardText}
  }

  return (
    <QuizAnimation question={question} animating={shouldAnimate} data={animationData}>
      <Card ref={ref} cardData={filteredData} example={imageMode} forcedCategory={questionCategory} />
    </QuizAnimation>
  )
})

export default QuizCard
